/** Client-side financial rollups for quotation PDF (aligned with backend computePricingTotals). */

import toOptNumber from "./toOptNumber";

export function computeQuotationFinancials(charges, gstPercentRaw, gstAmountRaw) {
  const list = Array.isArray(charges) ? charges : [];
  let sub = 0;
  for (const c of list) {
    if (c.type === "section") continue;
    if (c.includeInSubtotal === false) continue;
    if (c.amount == null || !Number.isFinite(Number(c.amount))) continue;
    sub += Number(c.amount);
  }
  sub = Math.round(sub * 100) / 100;
  const gAmt = toOptNumber(gstAmountRaw);
  const gPct = toOptNumber(gstPercentRaw);
  let gst = 0;
  if (gAmt != null && gAmt >= 0) gst = Math.round(gAmt * 100) / 100;
  else if (gPct != null && gPct > 0) gst = Math.round(sub * (gPct / 100) * 100) / 100;
  const total = Math.round((sub + gst) * 100) / 100;
  return { subTotal: sub, gstAmount: gst, totalAmount: total };
}

export function formatInr(amount) {
  if (amount == null || !Number.isFinite(Number(amount))) return "—";
  const n = Number(amount);
  return n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
